import { WritableSignal, signal } from "@angular/core";

export class ExtendedChartComponent {
  public _chartRef: WritableSignal<Highcharts.Chart | undefined> = signal(undefined);

  get chartRef(): Highcharts.Chart | undefined {
    return this._chartRef();
  }

  set chartRef(ref: Highcharts.Chart) {
    this._chartRef.set(ref);
  }

  toggleLegendItem(series?: string) {
    const chartRef = this._chartRef();
    if (!chartRef || !series) return;

    const index = seriesIndex(chartRef, series);
    if (index !== -1) {
      if (chartRef.series[index].visible) {
        chartRef.series[index].hide();
      } else {
        chartRef.series[index].show();
      }
    }
  }

  isSeriesHidden(series: string) {
    const chartRef = this._chartRef();
    if (!chartRef) return false;

    const index = seriesIndex(chartRef, series);
    if (index === -1) return false;
    return !chartRef.series[index].visible;
  }
}

function seriesIndex(chartRef: Highcharts.Chart, series: string) {
  // avoid recalculation of length on each iteration
  // and don't fail when series is undef
  const length = chartRef.series?.length ?? 0;
  for (let i = 0; i < length; i++) {
    if (chartRef.series[i].name === series) {
      return i;
    }
  }
  return -1;
}
